import React from 'react';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import { getSavedPayments } from 'hb-redux-store/feature/accounts/accounts.action';
import { connect } from 'react-redux';
import Cards from '../../components/mweb/Payments/Cards';
import Upis from '../../components/mweb/Payments/Upis';
import { validateUPI } from 'hb-redux-store/feature/checkout/checkout.action';
import RazorpayService from '../../hb-redux-store/util/RazorpayService';
import Icon from '../../components/mweb/Icon/Icon';

class SavedPayments extends React.Component {
  componentDidMount() {
    this.props.getSavedPayments();
    RazorpayService.initRazorpay();
  }

  render() {
    const { savedPayments, loading } = this.props;
    return (
      <div>
        <SecondaryNav
          source="accounts"
          showCart={false}
          showSearch={false}
          title="Saved Payments"
          capitalize
        />
        {loading && <Loader />}
        {!loading && savedPayments && (
          <div className="saved-payments">
            {savedPayments?.savedCards?.length > 0 && (
              <Cards
                title="Saved Cards"
                details={savedPayments.savedCards}
                source="accounts"
              />
            )}
            {savedPayments?.savedUPIs?.length > 0 && (
              <Upis
                title="Saved UPIs"
                details={savedPayments.savedUPIs}
                source="accounts"
                validateUPI={this.props.validateUPI}
              />
            )}
            {savedPayments?.savedCards?.length === 0 &&
              savedPayments?.savedUPIs?.length === 0 && (
                <div className="">
                  <div className="cart--empty-cart-icon">
                    <Icon class="icon-cart-empty-cart" size={142} />
                  </div>
                  <div className="cart--empty-cart-msg">
                    No saved payments details were found.
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ accountsReducer }) => ({
  savedPayments: accountsReducer.savedPayments,
  loading: accountsReducer.loading,
});
const mapDispatchToProps = {
  getSavedPayments,
  validateUPI,
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedPayments);
